import LoadingButton from '@mui/lab/LoadingButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';

const RefandiCard = ({ testId }: { testId?: string }): JSX.Element => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const viewLoanDocumentsClicked = (): void => {
    navigate(`/loan-documents`);
  };

  return (
    <li data-testid={testId}>
      <Card raised={false}>
        <figure>
          <CardMedia
            alt={t('DashboardGaragePage.refandi.description')}
            component={'img'}
            image={VehicleImagePlaceholder}
          />
        </figure>
        <CardContent>
          <h3>{t('DashboardGaragePage.refandi.description')}</h3>
          <h4>{t('DashboardGaragePage.refandi.applicationDescription')}</h4>
          <LoadingButton
            color="primary"
            loadingPosition="start"
            startIcon={<></>}
            type="button"
            variant="contained"
            fullWidth
            onClick={viewLoanDocumentsClicked}
          >
            {t('DashboardGaragePage.resume')}
          </LoadingButton>
        </CardContent>
      </Card>
    </li>
  );
};

export default RefandiCard;
